import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export interface WorkReportContactOption {
	contactId: string
	contactName: string
	mobile: string
}

export interface SearchWorkReportContactsParams {
	clientId: string
	q?: string
	limit?: number
}

const searchWorkReportContacts = async (
	params: SearchWorkReportContactsParams
): Promise<WorkReportContactOption[]> => {
	try {
		const { data } = await axios.get<WorkReportContactOption[]>(
			'v1/intelligence/management/contacts',
			{ params }
		)
		return Array.isArray(data) ? data : []
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default searchWorkReportContacts
